import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

const firebase_ = firebase;

export default {
	data() {
		return {
			firebase: firebase_
		}
	}
}